import { render, staticRenderFns } from "./CerfaForm.vue?vue&type=template&id=64719267&scoped=true"
import script from "./CerfaForm.vue?vue&type=script&lang=js"
export * from "./CerfaForm.vue?vue&type=script&lang=js"
import style0 from "./CerfaForm.vue?vue&type=style&index=0&id=64719267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64719267",
  null
  
)

export default component.exports